// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"76297284f50cb319b4c9","655":"b6820e58b8b04573581d"}[chunkId] + ".js";
};